import React, { useState } from "react";

const NewAccountL2 = () => {
  const [selectedOption, setSelectedOption] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleClick = () => {
    setIsChecked(!isChecked); // Toggle the checkbox state
  };

  return (
    <div className="p-5">
      <form className="">
        <h2 className="text-lg mb-4 mt-8">New Account</h2>
        <div className="flex mb-4 space-x-4 justify-between">
          {/* -----------------Account Type ----------------------*/}
          <div className="">
            <label className="block mb-6 mt-2 text-535252 text-14 font-500 rounded">Account Name*</label>

            <input
              type="text"
              className="border p-2  w-[301px] h-[35px] rounded"
              placeholder="Enter your account name"
            />
            <div className="">
              <label className=" block mb-6 w-[301px] p-2 text-535252 text-14 font-500 mt-4">Account Type*</label>

              <select className="h-10 w-[301px] rounded " value={selectedOption} onChange={handleChange}>
                <option value="" disabled>
                  Select an option
                </option>
                <option value="option1">Option 1</option>
                <option value="option2">Option 2</option>
                <option value="option3">Option 3</option>
              </select>
              <label htmlFor="customer_grp" className="block mb-4  text-[#2999BC] text-[12px] font-[400] ">
                <input
                  type="checkbox"
                  id="customer_grp"
                  name="customer_grp"
                  value="customer_grp"
                  className="me-2 appearance-none w-4 h-4 border border-[#2999BC] rounded-sm checked:border-[#2999BC] mt-4 focus:outline-none focus:ring-0 checked:bg-transparent relative checked:after:content-['✔'] checked:after:text-[#2999BC] checked:after:absolute checked:after:left-[2px] checked:after:top-[-3px]"
                  onClick={handleClick}
                />
                Make this A Subaccount
              </label>
            </div>
          </div>
          {/*------------------------- Account Number--------------- */}
          <div className="">
            <label className=" block mb-6 text-535252 text-14 font-500 rounded">Account Number</label>
            <input
              type="text"
              id="accountNumber"
              className="border p-2 w-[301px] rounded  h-[35px]"
              placeholder="Enter your account number"
            />
            <div className="flex mb-4 space-x-4">
              {/* --------------Detail Type---------------- */}
              <div className="">
                <label className="block mb-6  text-535252 text-14 p-2 font-500 mt-4">Detail Type*</label>

                <select className="h-10 w-[301px] rounded" value={selectedOption} onChange={handleChange}>
                  <option value="" disabled>
                    Select an option
                  </option>
                  <option value="option1">Option 1</option>
                  <option value="option2">Option 2</option>
                  <option value="option3">Option 3</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* ------------------Parent Account--------------------- */}
        <div className="">
          <label className=" block mb-2 mt-8  text-535252 text-14 font-500 rounded" htmlFor="parentAccount">
            Parent Account*
          </label>

          <select id="parentAccount" className="border w-full h-10" defaultValue=" ">
            <option value=" " disabled hidden></option>
            <option value="parent1">Parent Account 1</option>
            <option value="parent2">Parent Account 2</option>
            <option value="parent3">Parent Account 3</option>
          </select>
        </div>

        <div className=" h-14 items-center h-96px mb-4 mt-10">
          <label className="block mb-10 mt- text-535252 text-14 font-500 ">Description*</label>
          <input
            type="text"
            className=" flex-1 border h-[85px] p-2  w-full rounded  text-start"
            placeholder="Enter Detail"
          />
        </div>

        <div className={`flex justify-end pt-52 [h-50px] `}>
          <div></div>

          <button
            className={`text-535252 bg-F4F4F4 border border-EAE2E2 focus:ring-4 focus:ring-blue-300 font-medium text-sm  py-1.5 me-5 mb-2 px-4 focus:outline-none rounded-md`}
          >
            CANCEL
          </button>
          <button
            type="submit"
            className={`py-1.5 px-4 me-5 mb-2 text-sm font-medium text-white bg-1D4469 focus:outline-none w-12px focus:z-10 focus:ring-4 focus:ring-gray-100 rounded-md
                     `}
          >
            SAVE
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewAccountL2;
